import {Component, OnInit} from '@angular/core';
import {ContactMethodResponse} from "../../models/Common/contactMethodResponse";
import {NgxSpinnerService} from "ngx-spinner";
import {CommonService} from "../../services/common.service";
import {Router} from "@angular/router";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {AccountService} from "../../services/account.service";
import {Account} from "../../models/account/account";
import {PaymentInfo} from "../../models/Organization/organizationResponse";
import swal from "sweetalert2";

@Component({
  selector: 'app-external-contact',
  templateUrl: './external-contact.component.html',
  styleUrls: ['./external-contact.component.scss']
})
export class ExternalContactComponent implements OnInit {
  contactMethods: ContactMethodResponse[] = [];
  account: Account | undefined;
  paymentInfo: PaymentInfo | undefined;
  accountForm: FormGroup = new FormGroup({
    id: new FormControl(''),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    position: new FormControl('', Validators.required),
    email: new FormControl({value: '', disabled: true}),
    phone: new FormControl('', Validators.required),
    contactMethodId: new FormControl('', Validators.required),
    citizenship: new FormControl('', Validators.required),
    passport: new FormControl('', [Validators.required]),
    birthday: new FormControl('', Validators.required),
    placeOfBirth: new FormControl('', Validators.required),
    pOgOnR: new FormControl({value: '', disabled: true}, Validators.required),
  });

  constructor(private spinner: NgxSpinnerService,
              private accountService: AccountService, // Inject service
              private commonService: CommonService,
              private router: Router) {
  }

  async ngOnInit() {

    await this.spinner.show();
    Promise.all([
      this.loadContactMethods(),
      this.loadExternalContact(),
      this.loadPaymentInfo(),
    ]).finally(() => this.spinner.hide());

  }

  loadContactMethods() {
    return new Promise<void>((resolve, reject) => {
      this.commonService.getContactMethod().subscribe({
        next: (response) => {
          this.contactMethods = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading contact methods", error);
          reject(error);
        },
      });
    });
  }

  loadPaymentInfo() {
    return new Promise<void>((resolve, reject) => {
      this.accountService.getPaymentInfo().subscribe({
        next: (response) => {
          this.paymentInfo = response.item;
          resolve();
        },
        error: (error) => {
          console.error("Error loading paymentInfo", error);
          reject(error);
        },
      });
    });
  }

  loadExternalContact() {
    return new Promise<void>((resolve, reject) => {
      this.accountService.getInfo().subscribe({
        next: (response) => {
          this.account = response.item;
          if (this.account) {

            const birthday = this.account.birthday
              ? new Date(this.account.birthday)
              : null;


            this.accountForm.patchValue({
              id: this.account.id || '',
              firstName: this.account.firstName || '',
              lastName: this.account.lastName || '',
              position: this.account.position || '',
              email: this.account.email || '',
              phone: this.account.phone || '',
              contactMethodId: this.account.contactMethodId || null,
              citizenship: this.account.citizenship || '',
              passport: this.account.passport || '',
              birthday: birthday,
              placeOfBirth: this.account.placeOfBirth || '',
              pOgOnR: this.account.pOgOnR || ''
            });

          }
          resolve();
        },
        error: (error) => {
          console.error("Error loading contact", error);
          reject(error);
        },
      });
    });
  }

  async onSubmit() {
    this.accountForm.markAllAsTouched();
    if (this.accountForm.invalid) {

      const findInvalidControls = (form: FormGroup | FormArray, path: string = ''): string[] => {
        const invalidControls: string[] = [];
        Object.keys(form.controls).forEach(key => {
          const control = form.get(key);
          const controlPath = path ? `${path}.${key}` : key;


          if (control instanceof FormGroup || control instanceof FormArray) {
            invalidControls.push(...findInvalidControls(control, controlPath));
          } else if (control && control.invalid) {
            invalidControls.push(controlPath);
          }
        });
        return invalidControls;
      };


      const invalidControls = findInvalidControls(this.accountForm);

      console.warn('Invalid controls:', invalidControls);


      await swal.fire({
        title: 'Please fill in all required fields.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
    } else {
      const formData = this.accountForm.value;

      delete formData.pOgOnR;

      await this.spinner.show();

      this.accountService.save(formData).subscribe({
        next: (_) => {
          this.spinner.hide();
          if (_.result) {
            swal.fire({
              title: 'The contact has been updated successfully.',
              icon: 'success',
              confirmButtonText: 'OK',
            });
          } else {
            swal.fire({
              title: _.messages?.join(','),
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        },
        error: (_) => {
          this.spinner.hide();

        }
      });
    }

  }

  async addPaymentInfo() {
    await this.router.navigate(['/external-payment-info']);
  }
}
